import {
  Button,
  Drawer,
  message,
  Tabs,
  Tooltip,
  Input,
  Modal,
  Dropdown,
  Menu,
  Checkbox,
  Collapse,
  Progress,
  Select,
  Radio,
  Slider
} from "antd";
const { Panel } = Collapse;
const { Option } = Select;
import { connect } from "dva";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
  createContext,
  useReducer,
  useRef
} from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";
import IconFont from "@/components/icon";
import AdvanceRecord from "./components/AdvanceRecord";
import ExecutorsProgress from "./components/ExecutorsProgress";
import Comment from "../Comment";
import { EsuperviseSourceType, ICreateSuperviseData } from "@/types/supervise";
import GlobalContext from "@/context/GlobalContext";
import {
  createTaskGroup,
  deleteTask,
  getTaskDetail,
  modifyTaskInfo,
  getworkWpsPreViewCode
} from "@/api/work";
import {
  findSelfInExecutors,
  getTimeClassifyByTime,
  getDefaultStartTime,
  getDefaultStopTime
} from "../utils";
import { FocusSDK } from "@/utils";
import { changeEgovUrl, htmlUnescape } from "@/utils/tools";
import ChatMain from "@/baseComponents/Chat/view/Main";
import DatePicker from "../BaseComponents/DatePicker";

import Loading from "@/components/Loading";
import "./index.less";
import {
  NewTaskModel,
  PRIORITY_TYPE,
  PROCESS_STATUS,
  TaskListParams,
  TaskListByTaskGroupParams,
  TaskResource,
  TASK_STATUS
} from "@/types/newWork";
import {
  decorateTaskDetail,
  getTaskStatus,
  judgeTaskFinishOrStop,
  judgeTaskFinishAndStop,
  onShareClick
} from "../newUtils";
import { nanoid } from "nanoid";
import { getFileIconByMime, isChatPage, mattchUrl } from "@/utils/chat/index";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import bus from "@/utils/bus";
import { TaskPartEnum } from "@/types/work";
import { remindList } from "../CreateTaskDraw/index";
import { CaretLeftOutlined, CaretRightOutlined } from "@/utils/antdIcon";
import CryptoJS from "crypto-js";
import { ChatMessageBody, Session } from "@/types/chat";
import { PRIORITY_TYPE_MAP } from "@/components/Projects/emnu";
import syncConfirm, { syncConfirmNew } from "@/utils/syncConfirm";
// import ImService from '@/server/ImService';
import { getGroupInfo } from "@/api/egroup";
import Prompt from "@/baseComponents/ModalComponent/prompt";
// import { position } from 'html2canvas/dist/types/css/property-descriptors/position';
import debounce from "lodash/debounce";
import AttachmentComp from "@/components/AttachmentComp/handleAttachment";
import { openJoyspacePreview } from "@/components/Joyspace/util";
import TaskProcessModal, { FileStatus } from "../BaseComponents/TaskProcessModal";
import UserStatusListPopover from "@/baseComponents/UserStatusListPopover";
import UserListMore, { UserItem } from "@/baseComponents/UserListMore";
import BasicModal from "@/components/Calendars/Modal/BasicModal";
import BaseButton from "@/components/Calendars/Button";
import { BusinessForm } from "@/utils/chat/message";
let clickFn: undefined | Function;
// 立即沟通按钮的节流
const debounceFn = debounce(
  function () {
    clickFn?.();
  },
  999,
  { leading: true, trailing: false }
);
// 替换其他任务详情之后是否打开聊天抽屉
let openChatSoon = false;

const FORCE_GET = "1cf07dd502458e65675172405c2dc3db";

interface IState {
  fileList: any[];
}
const initialState: IState = {
  fileList: []
};

function reducer(state: IState, action: any) {
  const { payload } = action;
  switch (action.type) {
    case "changeState":
      return { ...state, ...payload };
    case "reloadAttchment": // 多端同步时，处理一下正在上传的文档
      // eslint-disable-next-line no-case-declarations
      const fileList: any[] = state.fileList.filter(
        (file: any) => file.status === FileStatus.Uploading
      );
      payload.list.forEach((l: any) => {
        fileList.push({
          fileName: l.name,
          size: l.size,
          fileType: l.fileType,
          fileId: l.bizId || nanoid(20),
          fileUrl: l.url,
          percent: 0,
          status: FileStatus.Done,
          resourceId: l.resourceId,
          icon: getFileIconByMime(l.fileType),
          creatorUserId: l?.creatorUserId
        });
      });
      return { ...state, fileList };
    default:
      throw new Error();
  }
}

export const TaskDetailContext = createContext<{
  taskDetail: NewTaskModel;
  setTaskDetail: any;
  closeDrawAndRefresh: Function;
}>({} as any);

// eslint-disable-next-line complexity
function TaskDetailDraw({
  userData,
  drawVisible,
  taskId,
  forceGet,
  chat,
  detailStateActiveTab,
  changePersonalTaskDraw,
  changeEditTaskDraw,
  openCreateSuperviseModal,
  getTasks,
  fetchTaskGroupsList,
  offset,
  fieldSortType,
  offsets,
  processStatuses,
  taskStatuses,
  priorityTypes,
  userRole,
  launchGroupSession,
  updateSelectedSession,
  selectedSession,
  scheduleInfoDraw,
  scheduleInfoDrawOther,
  changeScheduleInfoDraw,
  changeScheduleInfoDrawOther,
  groupId,
  getTasksByTaskGroup,
  activeKey
}: {
  drawVisible: boolean;
  userData: any;
  taskId: string;
  chat: boolean;
  forceGet: boolean;
  detailStateActiveTab: string;
  openCreateSuperviseModal: (opt: { visible: boolean; createData: ICreateSuperviseData }) => void;
  changePersonalTaskDraw: (
    taskId: string,
    visible: boolean,
    activeTab?: string,
    chat?: boolean
  ) => void;
  changeEditTaskDraw: (taskId: string, visible: boolean, taskDetail?: NewTaskModel | null) => void;
  getTasks: (params: TaskListParams) => void;
  getTasksByTaskGroup: (params: TaskListByTaskGroupParams) => void;
  fetchTaskGroupsList: () => void;
  offset: number;
  offsets: number[];
  processStatuses: PROCESS_STATUS[];
  taskStatuses: TASK_STATUS[];
  priorityTypes: PRIORITY_TYPE[];
  userRole: number;
  fieldSortType: number;
  launchGroupSession: Function;
  updateSelectedSession: Function;
  selectedSession: Session;
  scheduleInfoDraw: any;
  scheduleInfoDrawOther: any;
  changeScheduleInfoDraw: (payload: { visible: boolean; scheduleId: string }) => void;
  changeScheduleInfoDrawOther: (payload: { visible: boolean; scheduleId: string }) => void;
  groupId: string;
  activeKey: string;
}) {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation("work");
  const [t_chat] = useTranslation("chat");
  const [t_common] = useTranslation("common");
  const { imService, authInfo, appRuntimeEnv } = useContext(GlobalContext);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [dismissGroupModalVisible, setDismissGroupModalVisible] = useState(false);

  // 更改标题栏的背景
  const titleBlock = useRef(null);
  const [titleBlockClassname, setTitleBlockClassname] = useState("");
  const [intersectionObserver, __] = useState(function () {
    return new IntersectionObserver(
      function (entries) {
        console.log("Loaded new items", entries[0]);
        // If intersectionRatio is 0, the target is out of view
        // if (entries[0].intersectionRatio <= 0) {
        //     setTitleBlockClassname('whitening');
        // } else {
        //     setTitleBlockClassname('');
        // } isIntersecting
        setTitleBlockClassname(!entries[0].isIntersecting ? " whitening" : "");
      },
      { threshold: [0.329] }
    );
  });

  const { joyspaceHost } = appRuntimeEnv;
  const [taskDetail, setTaskDetail] = useState<NewTaskModel | null>(null);
  const [activeTab, setActiveTab] = useState(detailStateActiveTab || "/basicInfo");

  // const [titleInputVisible, setTitleInputVisible] = useState(false);
  const [chatVisable, setChatVisable] = useState(false);
  const { accessToken, teamUserInfo, userId, ddAppId } = authInfo;

  const promptDisband = useRef(false);
  const [remindArr, setRemindArr] = useState<string[]>(
    taskDetail?.remind ? taskDetail.remind.split(",") : []
  );

  // 个人推进
  const [pullRecords, setPullRecords] = useState(1);

  const [remark, setRemark] = useState(taskDetail?.remark?.remark || "");
  // 评论总条数
  const [countOfComment, setCountOfComment] = useState<number>(taskDetail?.taskCommentCount || 0);

  // 更新进展
  const [updateProcessVisible, setUpdateProcessVisible] = useState<boolean>(false);

  // 进度颜色
  const [statusColor, setStatusColor] = useState(getTaskStatus(TASK_STATUS.UNDONE));

  const showChat = useCallback(() => {
    if (!chat || !taskDetail) {
      return false;
    }
    const { executors, subscribers, owner, creator } = taskDetail;
    if (
      (!executors?.length && !subscribers?.length) ||
      (executors?.length === 1 &&
        executors[0].userId === owner?.userId &&
        subscribers?.length === 0) ||
      (subscribers?.length === 1 &&
        subscribers[0].userId === owner?.userId &&
        executors?.length === 0) ||
      (executors?.length === 1 &&
        executors[0].userId === owner?.userId &&
        subscribers?.length === 1 &&
        subscribers[0].userId === owner?.userId)
    ) {
      return false;
    }
    // 在协同人列表或者关注人列表或者是负责人才显示
    return (
      executors?.map((item: { userId: any }) => item.userId).includes(authInfo.userId) ||
      subscribers?.map((item: { userId: any }) => item.userId).includes(authInfo.userId) ||
      owner?.userId === authInfo.userId ||
      creator?.userId === authInfo.userId
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authInfo.userId, chat, taskDetail?.executors, taskDetail?.owner?.userId]);
  const handleLoadChat = useCallback(
    async (sid: string) => {
      // IM模块
      if (history.location.pathname.match(/messages/)) {
        if (history.location.pathname.includes(sid)) {
          history.push("/messages/");
          setTimeout(() => {
            history.push(`/messages/g/${sid}`);
          }, 200);
        } else {
          history.push(`/messages/g/${sid}`);
        }
        return;
      }
      // 任务模块
      if (sid) {
        await launchGroupSession({
          sid
        });
      }
      setChatVisable(true);
    },
    [launchGroupSession, history]
  );
  // 弹窗确认是否替换当前 日程 的详情页
  function replaceCalendarDetailDraw() {
    // 检测一下是否日程打开的
    let scheduleId;
    let type = "";
    if (scheduleInfoDraw?.visible && scheduleInfoDrawOther?.visible) {
      let scheduleInfoCur;
      if (scheduleInfoDraw.get() > scheduleInfoDrawOther.get()) {
        scheduleInfoCur = scheduleInfoDraw;
        type = "scheduleInfoDraw";
      } else {
        scheduleInfoCur = scheduleInfoDrawOther;
        type = "scheduleInfoDrawOther";
      }
      scheduleId = scheduleInfoCur.scheduleId;
    } else if ((scheduleId = scheduleInfoDraw?.scheduleId)) {
      type = "scheduleInfoDraw";
    } else if ((scheduleId = scheduleInfoDrawOther?.scheduleId)) {
      type = "scheduleInfoDrawOther";
    }
    if (!scheduleId) {
      return Promise.resolve(1);
    }

    return new Promise<any>((resolve, reject) => {
      Modal.confirm({
        title: t("tip"),
        content: (
          <span className="nimble-con">
            是否进入该任务的沟通组？
            <br />
            确认后原日程详情和沟通组将关闭。
          </span>
        ),
        className: "task-common-modal-lb",
        centered: true,
        okText: "确认",
        cancelText: "取消",
        onCancel: () => {
          resolve(0);
        },
        onOk: () => {
          if (type === "scheduleInfoDrawOther") {
            changeScheduleInfoDrawOther({
              visible: false,
              scheduleId: ""
            });
          } else {
            changeScheduleInfoDraw({
              visible: false,
              scheduleId: ""
            });
          }
          resolve(1);
        }
      });
    });
  }
  const handleChat = useCallback(
    // eslint-disable-next-line complexity
    async (ignore = false) => {
      window.console.log(77777, taskDetail, showChat());
      if (isChatPage()) {
        return message.warn(t_common("operate in main window"));
      }
      let deng = await replaceCalendarDetailDraw();
      if (!taskDetail || !showChat() || deng === 0) {
        return;
      }
      let needCreate = !taskDetail.groupId;
      updateSelectedSession({ selectedSession: {} });
      let confirmCreate;
      if (taskDetail.groupId) {
        // 判断群是否已解散
        const groupInfo = await getGroupInfo({
          groupIds: [{ groupId: taskDetail.groupId }]
        });

        const isDisband = groupInfo.groups[0].status === 0;
        const isOutOfGroup = groupInfo.groups[0].flag !== 3;
        if (isDisband) {
          // 先判断已解散
          if (ignore === true) {
            return;
          }
          const reCreate = await syncConfirm("该群已解散，是否重新创建群");
          if (!reCreate) {
            return;
          }
          confirmCreate = needCreate = true;
        } else if (isOutOfGroup) {
          // 未解散，不在群内
          if (ignore === true) {
            return;
          }
          const reJoin = await syncConfirm("您不在群内，是否选择加入？");
          if (reJoin) {
            const joinRes = await imService.joinGroup(taskDetail.groupId, {
              app: ddAppId,
              pin: userId,
              teamId: teamUserInfo.teamId
            });
            if (joinRes !== 0) {
              return message.error("重新加入失败");
            }
          }
        }
      }
      if (needCreate) {
        confirmCreate =
          confirmCreate ??
          (await syncConfirmNew(
            <span className="nimble-con">
              首次点击“立即沟通”会自动创建新群组，再次打开直接进入已创建群组。
            </span>,
            "确认要创建新的群组吗"
            // { icon: <ExclamationCircleFilled style={{ color: '#ED6A0C' }} /> } 不久会统一各模块的对话框，包括此图标
          ));
        if (!confirmCreate) {
          return;
        }
        const [res, err] = await createTaskGroup({
          taskId,
          from: {
            app: ddAppId || process.env.REACT_APP_DD_APPID || "",
            pin: taskDetail.owner.userId,
            teamId: taskDetail.owner.teamId,
            userId: taskDetail.owner.userId
          },
          body: {
            modifyFiled: 1,
            nickName: taskDetail.owner.realName,
            name: taskDetail.title.substring(0, 50),
            notice: "",
            gid: "",
            invitees: taskDetail.executors.map((i: any) => {
              return {
                pin: i.userId,
                app: ddAppId || process.env.REACT_APP_DD_APPID || "",
                nickName: i.realName,
                teamId: i.teamId,
                userId: i.userId
              };
            })
          },
          kind: 1024,
          subKind: 6
        });
        if (err) {
          return message.error(err);
        }
        taskDetail.groupId = res.groupId;
        handleLoadChat(taskDetail.groupId || "");
      } else {
        handleLoadChat(taskDetail.groupId || "");
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      taskDetail,
      showChat,
      updateSelectedSession,
      imService,
      ddAppId,
      userId,
      teamUserInfo.teamId,
      taskId,
      handleLoadChat
    ]
  );
  useEffect(() => {
    detailStateActiveTab && setActiveTab(detailStateActiveTab);
  }, [detailStateActiveTab]);
  // 当聊天的sessionId发生变化，聊天窗口的‘开启/关闭’需要处理
  useEffect(() => {
    if (selectedSession?.sessionId && chatVisable) {
      if (showChat()) {
        setChatVisable(true);
      } else {
        setChatVisable(false);
      }
    }
  }, [selectedSession?.sessionId]); // eslint-disable-line

  // fix:评论任务后im抽屉会关闭重新打开。 同时也做到：任务详情默认不展开聊天
  // useEffect(() => {
  //     if (taskDetail?.groupId && chat) {
  //         handleChat(true);
  //     }
  // }, [chat, handleChat, taskDetail]);
  useEffect(() => {
    if (taskDetail) {
      setRemindArr(
        taskDetail.remind ? taskDetail.remind.split(",").sort((a, b) => Number(b) - Number(a)) : []
      );
      setRemark(taskDetail?.remark?.remark || "");
      setCountOfComment(taskDetail.taskCommentCount || 0);
    }
  }, [taskDetail]);

  useEffect(() => {
    if (!drawVisible && location.pathname.includes("projects")) {
      chatVisable && updateSelectedSession({ selectedSession: {} });
    }
  }, [updateSelectedSession, drawVisible, location.pathname, chatVisable]);

  useEffect(() => {
    changePersonalTaskDraw("", false);
  }, [changePersonalTaskDraw, location]);

  useEffect(() => {
    let tem = titleBlock.current;
    if (drawVisible && tem) {
      // window.console.log(444, titleBlock);
      intersectionObserver.observe(tem);
      return () => {
        // window.console.log(555, tem);
        intersectionObserver.unobserve(tem!);
      };
    }
  }, [drawVisible, titleBlock.current]); // eslint-disable-line

  // 弹窗确认是否替换当前 任务 的详情页
  function replaceWorkDetailDraw() {
    return new Promise<any>((resolve, reject) => {
      Modal.confirm({
        title: t("tip"),
        content: (
          <span className="nimble-con">
            是否进入该任务详情页？
            <br />
            确认后原任务详情页将关闭。
          </span>
        ),
        className: "task-common-modal-lb",
        centered: true,
        okText: "确认",
        cancelText: "取消",
        onCancel: () => {
          changePersonalTaskDraw(taskDetail!.taskId, true, activeTab, true);
          reject(new Error());
        },
        onOk: () => {
          // 如果是从任务沟通群组分享过来的 则先关闭任务详情Draw
          // TODO
          setChatVisable(false);
          resolve(1);
        }
      });
    });
  }

  /**
   * 初始化数据
   */
  useEffect(() => {
    if (!taskId) {
      if (drawVisible) {
        message.error("无效的任务id");
        changeEditTaskDraw("", false);
        return;
      }
      setTaskDetail(null);
      return;
    }
    if (!drawVisible) {
      return;
    }

    let share = "";
    if (forceGet) {
      share = CryptoJS.AES.encrypt(`share:${accessToken}`, CryptoJS.enc.Utf8.parse(FORCE_GET), {
        iv: CryptoJS.enc.Utf8.parse("0102030405060708"),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString();
    }
    window.console.log("5555555", taskId, taskDetail);
    let p;
    if (taskId && chatVisable && taskDetail?.taskId) {
      if (taskId !== taskDetail?.taskId) {
        p = replaceWorkDetailDraw();
      } else {
        return;
      }
    } else {
      p = Promise.resolve(0);
    }
    p.then((v) => {
      if (v === 1) {
        openChatSoon = true;
      } else {
        openChatSoon = false;
      }
      getTaskDetail(taskId, share).then(([result, err]) => {
        if (err || !result || (result as any).content === null) {
          message.warn((err || (result as any).errorMsg) as string);
          changePersonalTaskDraw("", false);
          return;
        }
        const task = decorateTaskDetail(result as NewTaskModel);
        setTaskDetail(task);
        initFileList(task.resources || []);
        setRemark(task?.remark?.remark || "");
        setPullRecords(pullRecords + 1);
        if (task.processStatus === PROCESS_STATUS.NOT_VIEWED) {
          handleModifyDetailInfo({
            taskId: taskId,
            processStatus: PROCESS_STATUS.PUSHING
          });
        }
      });
    }).catch((v) => {
      window.console.log("cancel");
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    taskId,
    drawVisible,
    changePersonalTaskDraw,
    detailStateActiveTab,
    forceGet,
    accessToken,
    authInfo
  ]); // eslint-disable-line react-hooks/exhaustive-deps
  /**
   * 监听多端同步
   * 单独处理一下正在上传的附件
   * TODO: 需要根据实际情况处理
   */
  useEffect(() => {
    function reloadDetail(msg: any) {
      const { data, content } = msg;
      if (content?.includes("deleteTask")) {
        console.warn("删除任务", msg);
        return;
      }
      if (!data) {
        console.error("------->多端同步消息错误", msg);
        return;
      }
      const { timeclassify, part } = data;
      if (!taskId) {
        setTaskDetail(null);
        return;
      }
      if (!drawVisible) {
        return;
      }
      if (
        ![
          TaskPartEnum.PERSONAL_TASK,
          TaskPartEnum.MEANWHILE_TASK,
          TaskPartEnum.PROJECT_TASK
        ].includes(part)
      ) {
        return;
      }
      if (taskId !== data.taskId && Number(timeclassify) !== 999) {
        return;
      }
      let share = "";
      if (forceGet) {
        share = CryptoJS.AES.encrypt(`share:${accessToken}`, CryptoJS.enc.Utf8.parse(FORCE_GET), {
          iv: CryptoJS.enc.Utf8.parse("0102030405060708"),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }).toString();
      }

      getTaskDetail(taskId, share).then(([result, err]) => {
        if (err || !result || (result as any).content === null) {
          message.warn((err || (result as any).errorMsg) as string);
          changePersonalTaskDraw("", false);
          return;
        }
        const task = decorateTaskDetail(result as NewTaskModel);
        setTaskDetail(task);
        dispatch({
          type: "reloadAttchment",
          payload: {
            list: task.resources || []
          }
        });
      });
    }
    function handleNetworkChange(data: any) {
      const { connectState } = data;
      if (connectState.state === ConnectState.READY) {
        reloadDetail({ data: { taskId } });
      }
    }

    function onPromptDisbandChange(e: any) {
      console.log("e.target.checked==>", e.target.checked, typeof e.target.checked);
      promptDisband.current = e.target.checked;
    }
    async function imSpecialDisbandGroupEvent({ businessId, businessType, callback }: any) {
      if (businessType === "work") {
        promptDisband.current = false;
        Prompt({
          icon: <IconFont type="iconic_failure" style={{ color: "#F96137" }} />,
          title: "解散群提醒",
          content: (
            <span className="task-prompt-content">
              {t_chat("dismiss-group-prompt")}
              <span className="task-prompt-content">
                <Checkbox style={{ margin: "5px 5px 0 0" }} onChange={onPromptDisbandChange} />
                同时删除任务
              </span>
            </span>
          ),
          cancelText: "取消",
          onOk: async () => {
            if (promptDisband.current) {
              await deleteTask({ taskId: businessId, type: 1, delGroup: false });
            }
            callback();
          },
          okText: "确定"
        });
      }
    }

    bus.on("chat_message_multiSync_event:joyWork", reloadDetail);
    bus.on("chat:connect_state_change", handleNetworkChange);
    bus.on("im_special_disband_group_event", imSpecialDisbandGroupEvent);
    return () => {
      bus.off("chat_message_multiSync_event:joyWork", reloadDetail);
      bus.off("chat:connect_state_change", handleNetworkChange);
      bus.off("im_special_disband_group_event", imSpecialDisbandGroupEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    taskId,
    drawVisible,
    changePersonalTaskDraw,
    forceGet,
    accessToken,
    handleChat,
    t,
    promptDisband,
    t_chat,
    taskDetail
  ]);

  useEffect(() => {
    setStatusColor(getTaskStatus(taskDetail?.taskStatus));
  }, [taskDetail?.taskStatus]);
  function initFileList(list: TaskResource[]) {
    const fileList = list.map((l) => {
      return {
        fileName: l.name,
        size: l.size,
        fileType: l.fileType,
        fileId: l.bizId || nanoid(20),
        fileUrl: l.url,
        percent: 0,
        status: FileStatus.Done,
        resourceId: l.resourceId,
        icon: getFileIconByMime(l.fileType),
        creatorUserId: l?.creatorUserId
      };
    });
    dispatch({
      type: "changeState",
      payload: {
        fileList
      }
    });
  }

  // isHead 负责人或创建人 self协同人
  const [isHead, self, isOwnerOrExecutor, isSubscribers] = useMemo(() => {
    if (!taskDetail) {
      return [false, null, false];
    }
    let isHead = false;
    let self = null;
    let isOwnerOrExecutor = false;
    let isSubscribers = false;
    const ownerHeader = findSelfInExecutors([taskDetail.owner], userData);
    const creatorHeader = findSelfInExecutors(
      taskDetail.creator ? [taskDetail.creator] : [],
      userData
    );
    if (ownerHeader || creatorHeader) {
      isHead = true;
    }
    self = findSelfInExecutors(taskDetail.executors, userData);
    if (ownerHeader || self) {
      isOwnerOrExecutor = true;
    }
    const subHeader = findSelfInExecutors(taskDetail.subscribers, userData);
    if (subHeader) {
      isSubscribers = true;
    }
    return [isHead, self, isOwnerOrExecutor, isSubscribers];
  }, [taskDetail, userData]);

  const isTaskFinishOrStop = useMemo(() => {
    if (!taskDetail) {
      return false;
    }
    let isTaskFinishOrStop = false;
    if (judgeTaskFinishOrStop(taskDetail.taskStatus)) {
      isTaskFinishOrStop = true;
    }
    return isTaskFinishOrStop;
  }, [taskDetail]);
  const [isTaskFinish, isTaskStop] = useMemo(() => {
    if (!taskDetail) {
      return [];
    }
    let isTaskFinishAndStop = judgeTaskFinishAndStop(taskDetail.taskStatus);
    return isTaskFinishAndStop;
  }, [taskDetail]);

  const getTaskList = useCallback(() => {
    // 刚删除|编辑了（属于组任务的）任务，并且当前列表是组任务的，需要刷新如下俩
    fetchTaskGroupsList();
    if (activeKey === "task_group") {
      getTasksByTaskGroup({
        groupId,
        fieldSortType,
        taskStatuses,
        priorityTypes,
        limit: offsets ? offsets.length * 20 : 20,
        offset: 0
      });
      bus.emit("task:taskgroup_statistical");
      return;
    }
    getTasks({
      limit: offsets ? offsets.length * 20 : 20,
      offset: 0,
      // offsets: offsets,
      processStatuses: processStatuses,
      taskStatuses: taskStatuses,
      priorityTypes: priorityTypes,
      userRole: userRole,
      fieldSortType
    });
  }, [
    activeKey,
    getTasks,
    offsets,
    processStatuses,
    taskStatuses,
    priorityTypes,
    userRole,
    fieldSortType,
    fetchTaskGroupsList,
    getTasksByTaskGroup,
    groupId
  ]);

  const closeDraw = useCallback(() => {
    bus.emit("close-modal-detail");
    setChatVisable(false);
    setTaskDetail(null);
    // setTitleInputVisible(false);
    changePersonalTaskDraw(taskId, false, "/basicInfo");
    setActiveTab("/basicInfo");
  }, [changePersonalTaskDraw, taskId]);

  const handleEditTask = useCallback(() => {
    if (taskDetail?.taskGroupArchive) {
      return message.warning(t("Modify archived task prompt"));
    }
    setTaskDetail(null);
    setChatVisable(false);
    setActiveTab("/basicInfo");
    changeEditTaskDraw(taskId, true, taskDetail);
  }, [taskDetail, changeEditTaskDraw, taskId, t]);

  // 催办
  const handleDuClick = useCallback(
    (userList0?: any[]) => {
      if (!taskDetail) {
        return;
      }
      let userList: any[] = [];
      if (Array.isArray(userList0) && userList0.length > 0) {
        userList = userList0;
      } else {
        [taskDetail.owner, ...taskDetail.executors].forEach((user) => {
          const { userId, teamId, app, headImg, realName } = user;
          const index = userList.findIndex(
            (u: any) =>
              `${u.teamId}:${u.appId}:${u.userId}` === `${user.teamId}:${user.app}:${user.userId}`
          );
          if (index === -1) {
            userList.push({
              userId,
              teamId,
              appId: app,
              headImg,
              realName
            });
          }
        });
      }

      openCreateSuperviseModal({
        visible: true,
        createData: {
          id: taskDetail.taskId,
          title: taskDetail.title,
          userList,
          from: EsuperviseSourceType.WORK
        }
      });
    },
    [openCreateSuperviseModal, taskDetail]
  );

  const handleShareClick = useCallback(() => {
    onShareClick(taskDetail, userData);
  }, [userData, taskDetail]);

  const executorsMap = useMemo(() => {
    let temp = taskDetail?.executors || [];
    return {
      [PROCESS_STATUS.NOT_VIEWED]: temp.filter(
        (item) => item.processStatus === PROCESS_STATUS.NOT_VIEWED
      ),
      [PROCESS_STATUS.PUSHING]: temp.filter(
        (item) => item.processStatus === PROCESS_STATUS.PUSHING
      ),
      [PROCESS_STATUS.DIFFICULT]: temp.filter(
        (item) => item.processStatus === PROCESS_STATUS.DIFFICULT
      ),
      [PROCESS_STATUS.FINISHED]: temp.filter(
        (item) => item.processStatus === PROCESS_STATUS.FINISHED
      )
    };
  }, [taskDetail?.executors]);

  // async function handleTitleSave() {
  //     if (!taskDetail) {
  //         return;
  //     }
  //     if (!title.trim()) {
  //         message.warn(t('input task content'));
  //         return;
  //     }
  //     const isSuccess = await handleModifyDetailInfo({
  //         taskId: taskId,
  //         title: title,
  //     });
  //     if (isSuccess) {
  //         message.success(t('save success'));
  //         setTitleInputVisible(false);
  //     } else {
  //         return;
  //     }
  // }

  // 切换Tab
  function handleTabChange(key: string) {
    setActiveTab(key);
  }

  const handleTaskStatusChange = useCallback(
    async (status: number) => {
      if (!taskDetail) {
        return;
      }
      if (taskDetail?.taskGroupArchive) {
        return message.warning(t("Modify archived task prompt"));
      }
      const isSuccess = await handleModifyDetailInfo({
        taskId: taskId,
        taskStatus: status
      });
      if (isSuccess) {
        message.success(t("save success"));
        if (location.pathname?.indexOf("/calendar") > -1) {
          bus.emit("calendar:reloadSchedule");
        }
      }
    },
    [t, taskDetail, taskDetail, taskId] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const closeDrawAndRefresh = useCallback(() => {
    setTaskDetail(null);
    setChatVisable(false);
    // setTitleInputVisible(false);
    setActiveTab("/basicInfo");
    changePersonalTaskDraw(taskId, false);
    if (location.pathname?.indexOf("/calendar") > -1) {
      bus.emit("calendar:reloadSchedule");
    } else {
      getTaskList();
    }
  }, [changePersonalTaskDraw, getTaskList, location.pathname, taskId]);

  const delTaskFun = async (groupConfirm: boolean) => {
    setDismissGroupModalVisible(false);
    if (!taskId) {
      return message.error(t("delete fail"));
    }
    const [, err] = await deleteTask({ taskId: taskId, type: 1, delGroup: !groupConfirm });
    if (err) {
      return message.warn(err);
    }
    message.success(t("delete success"));
    closeDrawAndRefresh();
  };

  const handleDelTask = useCallback(async () => {
    if (!taskId) {
      return;
    }
    if (taskDetail?.taskGroupArchive) {
      return message.warning(t("Modify archived task prompt"));
    }
    const confirmDel = await syncConfirm(t("delete task info"), t("delete task"));
    if (confirmDel) {
      if (taskDetail?.groupId) {
        setDismissGroupModalVisible(true);
        return;
      }
      delTaskFun(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closeDrawAndRefresh, t, taskDetail?.groupId, taskDetail?.taskGroupArchive, taskId]);

  const tipContent = useMemo(() => {
    return (
      <div className="task-tip-wrapper" style={{ boxShadow: "rgba(0,0,0,.2) 0 0 10px" }}>
        <div className="tip-item">
          <div className="tip-title">整体完成</div>
          <div className="tip-content">
            只有任务的负责人有权限整体完成任务，点击“整体完成”后，任务将被整体标记为完成。如需要编辑或重新开始任务，可操作重启任务。
          </div>
        </div>
        <div className="tip-item">
          <div className="tip-title">中止</div>
          <div className="tip-content">
            中止代表中途暂停任务。如需要编辑或重新开始任务，可操作重启任务。
          </div>
        </div>
      </div>
    );
  }, []);

  // 立即沟通按钮的点击事件回调
  clickFn = useMemo(() => {
    window.console.log("1111-bbbbbb-1111", taskDetail?.taskId);
    const retFn = () => {
      window.console.log(1111);
      chatVisable ? setChatVisable(false) : handleChat();
    };
    if (openChatSoon) {
      setTimeout(retFn);
      openChatSoon = false;
    }
    return retFn;
  }, [handleChat, chatVisable]); // eslint-disable-line react-hooks/exhaustive-deps

  // TODO: 根据实际情况处理result err
  async function handleModifyDetailInfo(data?: any) {
    const [result, err] = await modifyTaskInfo(data);
    if (err) {
      message.warn(err as string);
      return false;
    }
    const task = decorateTaskDetail(result as NewTaskModel);
    setTaskDetail(task);
    getTaskList();
    !!task.taskGroupIds?.length && fetchTaskGroupsList();
    return result;
  }

  // 保存‘我的备注’
  async function saveRemark(event: any) {
    if (!event.ctrlKey) {
      const res = await handleModifyDetailInfo({
        taskId: taskId,
        remark: {
          id: taskDetail?.remark?.id,
          remark: event.target.value
        }
      });
      if (res) {
        message.success("保存成功");
      }
    }
  }
  function handleRemarkChange(e: any) {
    setRemark(e.target.value || "");
  }

  async function onAttachmentRemove(fileId: string) {
    if (!taskDetail) {
      return;
    }
    const delResource = taskDetail.resources.find((item) => item.bizId === fileId);
    if (!delResource) {
      return;
    }
    const isSuccess = await handleModifyDetailInfo({
      taskId: taskId,
      delResources: [delResource]
    });
    if (isSuccess) {
      message.success(t("attachment remove success"));
    }
    return;
  }

  const openPreviewWps = useCallback(
    async (item: any) => {
      const opt = {
        fileUrl: item.fileUrl,
        taskId: taskId || taskDetail?.taskId,
        userId: (taskDetail?.owner as any).creatorUserId || taskDetail?.owner.userId,
        teamId: taskDetail?.owner.teamId || "",
        fileId: item.fileId
      };
      const [result, err] = await getworkWpsPreViewCode(opt);
      if (err || !result) {
        message.error(err || "该文件暂不支持预览");
        return false;
      }
      openJoyspacePreview({
        code: result.code,
        host: joyspaceHost,
        isShowHeader: 1,
        canSaveToJoyspace: 1,
        canDownload: 1
      });
    },
    [joyspaceHost, taskDetail, taskId]
  );

  // 更新进度
  const updateProcessAction = async (params: any, cb: Function) => {
    const isSuccess = await handleModifyDetailInfo(params);
    if (isSuccess) {
      message.success(t("save success"));
      setPullRecords(pullRecords + 1);
    }
    cb();
  };

  const handleList = useCallback((data) => {
    const setData = data?.map((item: any) => {
      return {
        ...item,
        isRemove: true
      };
    });

    return setData;
  }, []);

  const subscribers = useMemo(() => {
    if (!taskDetail) return [];
    if (taskDetail.subscribers?.length > 6) {
      return taskDetail.subscribers.slice(0, 5);
    }
    return [...(taskDetail.subscribers || [])];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskDetail?.subscribers]);

  if (!drawVisible) {
    return null;
  }

  // userRole可能不准确（比如在im菜单下打开任务的时候）
  if (taskDetail && !taskDetail.userRoles!.includes(userRole)) {
    userRole = taskDetail.userRoles![0] as number; // eslint-disable-line
  }

  return (
    <Drawer
      width={450}
      placement="right"
      style={{
        transform: chatVisable ? "translate(-430px)" : "inherit",
        zIndex: 100
      }}
      title={
        <div className={`detail-header${titleBlockClassname}`}>
          <div>
            {t("task detail")}
            {(isHead || self) && (
              <b className="myRole">
                (我{`${userRole === 1 ? "负责" : userRole === 0 ? "创建" : "协同"}`}
                的)
              </b>
            )}
          </div>
          <div className="header-btn-wrapper">
            {(isHead || self) && (
              <div
                title={t_common("button.edit")}
                clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_taskdetail_edit"
                className="action-du action-button app-region-none"
                onClick={handleEditTask}
              >
                <IconFont type="iconrdit" />
              </div>
            )}
            {(isHead || self || isSubscribers) && !isTaskFinishOrStop && (
              <div
                title="催办"
                style={{ display: isTaskFinish ? "none" : "" }}
                clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_taskdetail_urge"
                className="action-du action-button app-region-none"
                onClick={() => handleDuClick()}
              >
                <IconFont type="iconzw_app_remind1" />
              </div>
            )}
            {(isHead || self) && (
              <>
                <div
                  title={t_common("button.share")}
                  clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_taskdetail_share"
                  className="action-share action-button app-region-none"
                  onClick={handleShareClick}
                >
                  <IconFont type="iconshare" />
                </div>
                {isHead && (
                  <div
                    title={t_common("button.delete")}
                    clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_taskdetail_delete"
                    className="action-du action-button app-region-none"
                    onClick={handleDelTask}
                  >
                    <IconFont type="icondelect" />
                  </div>
                )}
              </>
            )}
            <div
              title={t_common("button.close")}
              className="action-close action-button app-region-none"
              onClick={closeDraw}
            >
              <IconFont type="iconapp_btn_file_cancel" />
            </div>
          </div>
        </div>
      }
      closable={false}
      onClose={closeDraw}
      className="work-detail-draw"
      visible={true}
      destroyOnClose={true}
    >
      {!taskDetail ? (
        <div className="draw-loading">
          <Loading />
        </div>
      ) : (
        <>
          <div className="detail-mainbody">
            <div className="detail-title-box" ref={titleBlock}>
              <div className="title-wrapper">
                <div
                  className="title-wrapper-status title-wrapper-status-progress"
                  style={{
                    color: statusColor?.color,
                    background: statusColor?.bgcolor
                  }}
                >
                  {taskDetail?.totalProgress || 0}%
                </div>
                <Tooltip
                  placement="bottom"
                  arrowPointAtCenter
                  overlayClassName="task-detail-title-tooltip"
                  title={<div className="user-select-text">{htmlUnescape(taskDetail?.title)}</div>}
                >
                  <span className="user-select-text title-wrapper-title">
                    {htmlUnescape(taskDetail?.title)}
                  </span>
                </Tooltip>
                {/* 任务已终止且是任务负责人或创建人可以重启任务 */}
                {isHead && taskDetail?.taskStatus === TASK_STATUS.ABORT && (
                  <div
                    className="title-wrapper-status title-wrapper-status-btn"
                    clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_taskdetail_advancerecord_commit3"
                    onClick={() => {
                      handleTaskStatusChange(1);
                    }}
                  >
                    <span>{t("restart")}</span>
                  </div>
                )}
                {(isHead || self) && taskDetail?.taskStatus === TASK_STATUS.UNDONE && (
                  <div
                    className="title-wrapper-status title-wrapper-status-btn"
                    clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_taskdetail_advancerecord_commit1"
                    onClick={() => {
                      if (taskDetail?.taskGroupArchive) {
                        return message.warning(t("Modify archived task prompt"));
                      }
                      // 如果我仅是协同人且上一次更新的进度正在审核中
                      // if (!isHead && self && (self as any)?.processAuditStatus === 0) {
                      //   return message.warning(
                      //     "您有一条任务进度审批中，审批完成后方可再次提交新的进度。"
                      //   );
                      // }
                      setUpdateProcessVisible(true);
                    }}
                  >
                    {isHead ? <span>更新状态</span> : <span>更新进展</span>}
                  </div>
                )}
              </div>
            </div>
            <div className="detail-content">
              <div className="content-basic">
                <div
                  className="detail-content-item task-textarea-item"
                  style={{
                    alignSelf: "flex-start",
                    display: !taskDetail.content ? "none" : ""
                  }}
                >
                  {/* <div className="label">描述</div> */}

                  <div className="textarea-button">
                    {taskDetail.content ? (
                      <div
                        className="textarea-text user-select-text"
                        dangerouslySetInnerHTML={{
                          __html: mattchUrl(taskDetail.content)
                        }}
                      />
                    ) : (
                      <div className="textarea-text textarea-text-empty">{t("no description")}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="divider-block" />
            <TaskDetailContext.Provider value={{ taskDetail, setTaskDetail, closeDrawAndRefresh }}>
              <Tabs
                // size="small"
                // tabBarGutter={20}
                activeKey={activeTab}
                onChange={handleTabChange}
                className="tab-wrapper"
                defaultActiveKey="/basicInfo"
              >
                <Tabs.TabPane
                  tab={
                    <span clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_basic-information">
                      {t("basic-information")}
                    </span>
                  }
                  key="/basicInfo"
                >
                  <div className="detail-content">
                    <div className="content-basic">
                      <div className="detail-content-item task-owner-item">
                        <div className="label">执行人员</div>
                        <div className="owner-container">
                          <UserListMore
                            disable={true}
                            addMemberDisable={isTaskFinishOrStop || !isHead}
                            list={[taskDetail.owner]}
                            maxLength={8}
                            isShowName={true}
                            notAvatar={true}
                            notTooltip={true}
                            title={taskDetail.title}
                            mode="taskDetail"
                            taskUserRole={1}
                          />
                          <span style={{ flex: 1, marginLeft: 6 }}>负责</span>
                        </div>
                        {!!taskDetail.executors.length && (
                          <>
                            <span className="basic-information-line" />
                            <div className="cooperate">
                              <div className="executor-container">
                                <UserStatusListPopover
                                  popoverName="getTaskDetailContent"
                                  list={executorsMap}
                                  userData={userData}
                                  taskDetail={taskDetail}
                                  showAdvance={true}
                                  isTaskRelatedPersonnel={!!(isHead || self || isSubscribers)}
                                  isQueryAuditList={isOwnerOrExecutor}
                                  userPopover="task"
                                  userPopoverText="colaborator"
                                  disable={true}
                                  mode="detail"
                                >
                                  <div
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                    }}
                                  >
                                    <UserListMore
                                      list={taskDetail.executors}
                                      isShowName={true}
                                      notAvatar={true}
                                      maxLength={3}
                                      disable={true}
                                      title={taskDetail.title}
                                      notTooltip={true}
                                      userPopover="task"
                                      userPopoverText="colaborator"
                                      mode="detail"
                                      userNoClick={true}
                                      taskUserRole={2}
                                    />
                                  </div>
                                </UserStatusListPopover>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                      {!!taskDetail?.subscribers.length && (
                        <div className="detail-content-item task-subscribers-item">
                          <div className="label">关注人员</div>
                          <div className="cooperate">
                            <div className="subscribers-container">
                              <UserStatusListPopover
                                popoverName="getTaskContent"
                                list={handleList(taskDetail?.subscribers)}
                                userPopover="task"
                                userPopoverText="subscribers"
                                onRemove={(data: any[]) => {}}
                                disable={true}
                                mode="detail"
                              >
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                  }}
                                >
                                  <UserListMore
                                    list={taskDetail.subscribers}
                                    isShowName={true}
                                    notAvatar={true}
                                    maxLength={4}
                                    disable={true}
                                    title={taskDetail.title}
                                    notTooltip={true}
                                    userPopover="task"
                                    userPopoverText="subscribers"
                                    mode="detail"
                                    userNoClick={true}
                                    taskUserRole={4}
                                  />
                                </div>
                              </UserStatusListPopover>
                            </div>
                          </div>
                        </div>
                      )}
                      <div
                        className="detail-content-item task-timerange-item common-single-item"
                        style={{
                          display:
                            !taskDetail.workStartTime && !taskDetail.workStopTime ? "none" : ""
                        }}
                      >
                        <div className="label">任务时间</div>
                        <div className="timerange-container">
                          <div className="time-button time-button-star" style={{ height: 32 }}>
                            <DatePicker
                              time={taskDetail.workStartTime || null}
                              disable={true}
                              placeholder={t("no start time")}
                              defaultTime={getDefaultStartTime()}
                              onEndTime={taskDetail.taskId}
                            />
                          </div>
                          <div className="button-split" />
                          <div
                            className={`time-button ${taskDetail.dueTag ? "time-button-end" : ""}`}
                            style={{ height: 32 }}
                          >
                            <DatePicker
                              time={taskDetail.workStopTime || null}
                              disable={true}
                              placeholder={t("no end time")}
                              defaultTime={getDefaultStopTime()}
                              onEndTime={taskDetail.taskId}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="detail-content-item task-remind-item common-single-item">
                        <div className="label">重要程度</div>
                        <div className="textarea-button" style={{ justifyContent: "inherit" }}>
                          {taskDetail?.priorityType &&
                            taskDetail.priorityType !== PRIORITY_TYPE.NO_PRIORITY && (
                              <>
                                <img
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "6px"
                                  }}
                                  src={changeEgovUrl(
                                    PRIORITY_TYPE_MAP[taskDetail.priorityType].url
                                  )}
                                  alt={PRIORITY_TYPE_MAP[taskDetail.priorityType].alt}
                                />
                                <span>{PRIORITY_TYPE_MAP[taskDetail.priorityType].text}</span>
                              </>
                            )}
                        </div>
                      </div>
                      {remindArr.length && remindArr[0] !== "0" ? (
                        <div className="detail-content-item task-remind-item common-single-item">
                          <div className="label">逾期提醒</div>
                          <div className="textarea-button">
                            <div className="textarea-text">
                              {remindArr
                                .map((v) => {
                                  return remindList.find((o) => o.value === String(v))?.label;
                                })
                                .join("、")}
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div
                        className="detail-content-item task-textarea-item"
                        style={{
                          alignSelf: "flex-start",
                          display: !taskDetail?.taskGroups?.length ? "none" : ""
                        }}
                      >
                        <div className="label">任务分组</div>

                        <div className="textarea-button">
                          <div
                            className="textarea-text user-select-text"
                            dangerouslySetInnerHTML={{
                              __html: mattchUrl(
                                taskDetail.taskGroups?.map((item) => item.groupName).join("、") ||
                                  ""
                              )
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {state.fileList?.length ? (
                      <div className="content-part-other">
                        <div className="detail-content-item task-attachment-item">
                          <div className="label">
                            {t("attachment")} ({state.fileList?.length})
                          </div>

                          <AttachmentComp
                            businessForm={BusinessForm.TASK}
                            disabled={true}
                            mode="detail"
                            onRemove={onAttachmentRemove}
                            fileList={state.fileList}
                            openPreviewWps={openPreviewWps}
                            uploadControlName="task-detail-upload-panel"
                            bizId={taskDetail?.taskId}
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                </Tabs.TabPane>
                <Tabs.TabPane
                  tab={
                    <span
                      className="task-tab-tip"
                      clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_detailpage_advancerecords"
                    >
                      {t("advance-record")}
                      {taskDetail.haveProcessAudit === 1 && taskDetail.userRoles![0] === 1 ? (
                        <span className="red-tip" />
                      ) : null}
                    </span>
                  }
                  key="/processRecord"
                >
                  <AdvanceRecord
                    isTaskFinishOrStop={isTaskFinishOrStop}
                    isHead={isHead}
                    isExecutorsSelf={self ? true : false}
                    isQueryAuditList={isOwnerOrExecutor}
                    pullRecords={pullRecords}
                    handleReject={() => {
                      getTaskList();
                      getTaskDetail(taskId, "")
                        .then(([result, err]) => {
                          if (err || !result || (result as any).content === null) {
                            message.warn((err || (result as any).errorMsg) as string);
                            changePersonalTaskDraw("", false);
                            return;
                          }
                          const task = decorateTaskDetail(result as NewTaskModel);

                          setTaskDetail(task);
                        })
                        .catch((v) => {
                          window.console.log("cancel");
                        });
                    }}
                    owner={taskDetail.owner}
                  />
                </Tabs.TabPane>
                {taskDetail.executors.length && (
                  <Tabs.TabPane
                    tab={
                      <span clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_detailpage_executors">
                        {t("executors-progress")}
                      </span>
                    }
                    key="/executorsProgress"
                  >
                    <ExecutorsProgress
                      members={taskDetail.executors}
                      urgeSomeOne={!isTaskFinishOrStop && handleDuClick}
                      isTaskRelatedPersonnel={!!(isHead || self || isSubscribers)}
                    />
                  </Tabs.TabPane>
                )}
                <Tabs.TabPane
                  tab={
                    <span clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_detailpage_comments">
                      {t("comment")}
                      {!!countOfComment &&
                        countOfComment > 0 &&
                        countOfComment <= 99 &&
                        " " + countOfComment}
                      {!!countOfComment && countOfComment > 99 && " 99+"}
                    </span>
                  }
                  key="/comment"
                >
                  <Comment
                    isHead={isHead}
                    isExecutorsSelf={self ? true : false}
                    isSubscribers={isSubscribers}
                    setCountOfComment={setCountOfComment}
                    taskId={taskDetail?.taskId}
                    isTaskRelatedPersonnel={!!(isHead || self || isSubscribers)}
                    countOfComment={countOfComment}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane
                  tab={
                    <span clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_mynote">
                      {t("my note")}
                    </span>
                  }
                  key="/mynote"
                >
                  <div className="content-part-other">
                    <div className="detail-content-item task-textarea-item task-mynote-item">
                      <div className="textarea-container">
                        <Input.TextArea
                          autoSize
                          placeholder="请输入"
                          // defaultValue={remark}
                          defaultValue={htmlUnescape((taskDetail.remark).remark)}
                          maxLength={500}
                          onChange={handleRemarkChange}
                          onPressEnter={saveRemark}
                          onBlur={saveRemark}
                          disabled={!(isHead || self || isSubscribers)}
                        />
                      </div>
                    </div>
                  </div>
                </Tabs.TabPane>
              </Tabs>
            </TaskDetailContext.Provider>
          </div>
          {/* 驳回 */}
          {(self as any)?.processAuditStatus === 2 && (
            <div
              className="detail-mainbody-tip"
              onClick={() => {
                setUpdateProcessVisible(true);
              }}
            >
              您有一条进展更新被驳回，点击查看详情
            </div>
          )}
          {showChat() && (
            <div
              className="chat-connect-btn"
              clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_taskdetail_IMgroupcommunicate"
              onClick={debounceFn}
            >
              {chatVisable ? "收起聊天" : "立即沟通"}
            </div>
          )}
        </>
      )}
      {updateProcessVisible && (
        <TaskProcessModal
          task={taskDetail}
          isHead={isHead}
          executor={self}
          setUpdateProcessVisible={setUpdateProcessVisible}
          updateProcessAction={updateProcessAction}
          uploadControlName="task-detail-process-panel"
        />
      )}
      {showChat() && (
        <div className="chat-switch-btn-wrap" style={{ right: 450 }}>
          <Button
            clstag={`pageclick|keycount|${
              !chatVisable ? "xtbg_add_task|xtbg_add_task_taskdetail_IMgroupcommunicate" : ""
            }`}
            onClick={debounceFn}
          >
            {chatVisable ? <CaretRightOutlined /> : <CaretLeftOutlined />}
          </Button>
        </div>
      )}
      <Drawer // 聊天抽屉
        title={null}
        width={430}
        className="task-chat-drawer"
        mask={false}
        closable={false}
        onClose={() => {
          setChatVisable(false);
        }}
        visible={chatVisable}
      >
        <ChatMain hideSetting={true} singleLine={true} />
      </Drawer>
      <BasicModal
        title={t("tip")}
        centered={true}
        visible={dismissGroupModalVisible}
        className="task-change-confirm-modal"
        onCancel={() => {
          setDismissGroupModalVisible(false);
        }}
        footer={
          <div className="footer df">
            <BaseButton size="small" type="default" onClick={() => delTaskFun(false)}>
              {t("dissolve the group")}
            </BaseButton>
            <BaseButton
              size="small"
              type="primary"
              className="ml24"
              onClick={() => delTaskFun(true)}
            >
              {t("keep the group")}
            </BaseButton>
          </div>
        }
      >
        <p>{t("after deleting the task, will the associated group be retained")}</p>
      </BasicModal>
    </Drawer>
  );
}
function mapStateToProps({ work, user, calendar, chat }: any) {
  const { detailState } = work;
  return {
    detailStateActiveTab: detailState.activeTab,
    userData: user.userData.user,
    drawVisible: detailState.drawVisible,
    taskId: detailState.taskId,
    forceGet: detailState.forceGet,
    chat: detailState.chat,
    offset: work.offset,
    fieldSortType: work.fieldSortType,
    offsets: work.offsets,
    processStatuses: work.processStatuses,
    taskStatuses: work.taskStatuses,
    priorityTypes: work.priorityTypes,
    userRole: work.userRole,
    selectedSession: chat.selectedSession,
    scheduleInfoDraw: calendar.scheduleInfoDraw,
    scheduleInfoDrawOther: calendar.scheduleInfoDrawOther,
    groupId: work.groupId,
    activeKey: work.activeKey
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    changePersonalTaskDraw: (
      taskId: string,
      visible: boolean,
      activeTab?: string,
      chat?: false
      // eslint-disable-next-line max-params
    ) =>
      dispatch({
        type: "work/changePersonalTaskDraw",
        payload: { taskId, drawVisible: visible, activeTab, chat }
      }),
    changeEditTaskDraw: (taskId: string, visible: boolean, taskDetail: NewTaskModel) =>
      dispatch({
        type: "work/changeEditTaskDraw",
        payload: { taskId, drawEditVisible: visible, taskDetail }
      }),
    openCreateSuperviseModal: (opt: { visible: boolean; createData: ICreateSuperviseData }) => {
      dispatch({
        type: "supervise/setCreateModalVisible",
        payload: opt
      });
    },
    getTasks(payload: TaskListParams) {
      return dispatch({
        type: "work/fetchTaskList",
        payload
      });
    },
    getTasksByTaskGroup(payload: TaskListByTaskGroupParams) {
      return dispatch({
        type: "work/fetchTaskListByTaskGroup",
        payload
      });
    },
    launchGroupSession(data: { sid: string }) {
      dispatch({ type: "chat/launchGroupSession", payload: data });
    },
    updateSelectedSession(data: {}) {
      dispatch({ type: "chat/updateSelectedSession", payload: data });
    },
    changeScheduleInfoDraw: (payload: { visible: boolean; scheduleId: string }) =>
      dispatch({
        type: "calendar/changeScheduleInfoDraw",
        payload
      }),
    changeScheduleInfoDrawOther: (payload: { visible: boolean; scheduleId: string }) =>
      dispatch({
        type: "calendar/changeScheduleInfoDrawOther",
        payload
      }),
    fetchTaskGroupsList() {
      return dispatch({
        type: "work/queryTaskGroupsList"
      });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(TaskDetailDraw);
